// Set per environment in .env.development (local), .env.uat and .env.prod
export default () => {
  return (
    process.env.REACT_APP_HOST_URL ||
    "https://jobmacha-backoffice-dev.navarch.app/#"
  );
};
